import TextareaAutosize from "react-textarea-autosize";
import { CheckIcon, CopyIcon, ReloadIcon } from "@radix-ui/react-icons";
import Lottie from "react-lottie";
import AnimationData from "@/data/animation.json";
import React from "react";

import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

const AIToolsResponse = ({ response, onRegenerate }: { response: string; onRegenerate: any }) => {
  const [copy, isCopied] = useCopyToClipboard();

  const onCopy = async () => {
    console.log({ response });
    if (response) {
      await copy({ text: response, timeout: 5000 });
    }
  };
  return (
    <div className="card bg-base-200/70 flex flex-1 justify-start space-y-4 rounded-lg bg-black p-2 py-4 align-middle text-white sm:border-2 sm:border-gray-600 sm:p-3 ">
      {response && (
        <div className="card bg-base-200/70 flex h-full w-full flex-1 flex-col justify-between rounded-lg p-2 align-middle sm:p-4">
          <div className="relative flex h-full flex-1 cursor-pointer space-x-2 rounded-md border-gray-500 p-2">
            <TextareaAutosize
              className="textarea flex flex-1 items-start justify-start p-4 pr-16 text-left text-base sm:pr-12"
              cacheMeasurements={false}
              value={response}
            />
            <button
              className="btn btn-outline btn-active btn-sm absolute right-20 top-20"
              style={{ right: 20, top: 20 }}
              onClick={() => onCopy()}
            >
              {isCopied ? <CheckIcon className="size-4" /> : <CopyIcon className="size-4" />}
            </button>
          </div>
          <div className="mt-4 flex flex-1 flex-row items-end justify-start">
            <div className="flex flex-1 space-x-4">
              <button className="btn btn-sm btn-outline btn-primary font-bold" onClick={onRegenerate}>
                <ReloadIcon className="size-4" /> Regenerate
              </button>
              <button className="btn btn-outline btn-active btn-sm" onClick={onCopy}>
                <CopyIcon className="size-4" /> Copy
              </button>
            </div>
            <div className="hidden sm:block">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: AnimationData,
                }}
                height={80}
                width={80}
              />
            </div>
          </div>
        </div>
      )}
      {!response && (
        <div className="bg-base-200/70 relative flex  h-full w-full flex-1 flex-col py-4">
          <h3 className="mb-5 w-full text-center text-3xl">Waiting for the response</h3>
          <div className="h-full w-full p-20">
            <img src="/assets/waiting.svg" alt="Waiting for the response" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AIToolsResponse;
